import React from 'react'
import classes from './SchoolNoteSchoolForm.module.sass'
import Typography from '../Typography'

const SchoolView = ({
  school: {
    districtName,
    address,
    phone,
    principal,
    prinEmail,
    secretary,
    sec1Email
  },
}) => (
  <>
    <label>
      District:
      <Typography classes={classes.p}>{districtName}</Typography>
    </label>
    <label>
      Address:
      <Typography classes={classes.p}>{address}</Typography>
    </label>
    <label>
      Phone:
      <Typography classes={classes.p}>{phone}</Typography>
    </label>
    <div>
      <h6 className={classes.h6}>Principal</h6>
      <label>
        Name:
        <Typography classes={classes.p}>{principal}</Typography>
      </label>
      <label>
        Email:
        <Typography classes={classes.p}>{prinEmail}</Typography>
      </label>
    </div>
    <div>
      <h6 className={classes.h6}>Secretary</h6>
      <label>
        Name:
        <Typography classes={classes.p}>{secretary}</Typography>
      </label>
      <label>
        Email:
        <Typography classes={classes.p}>{sec1Email}</Typography>
      </label>
    </div>
  </>
)

export default SchoolView
